import { Button } from "antd";
import { useTranslation } from "react-i18next";

const CancelBtn = () => {
  const [t] = useTranslation("common");
  return (
    <Button
      style={{
        color: "#1677FF",
        border: "1px solid #1677FF",
        marginInlineEnd: "auto",
      }}
      className="btn"
      size="large"
      // eslint-disable-next-line no-restricted-globals
      onClick={() => history.go(-1)}
    >
      {t("cancel")}
    </Button>
  );
};

export default CancelBtn;
